import * as ngCore from '@angular/core'

import { AtnDsTableStore } from '../../../../store'

import * as attachedOverlay from './attached-overlay'

@ngCore.Component({
  imports: [attachedOverlay.Component],
  selector: 'settings-action',
  standalone: true,
  template: `
      <i
        class="atn-icon atn-track-detail"
        (click)="settingsIconClickHandler()"
        #settingsOverlayRef
      >
      </i>
      @if(_store.columnSettingsIsOpenSg()) {
        <settings-action-attached-overlay
          [origin]="settingsOverlayRef" 
        />
      }
  `,
})
export class Component {
  /** @see {@link AtnDsTableStore} */
  // NOTE: Only public for template purposes
  public readonly _store = ngCore.inject(AtnDsTableStore)
  /** TODO:  */
  public settingsIconClickHandler() {
    this._store.patchState({ columnSettingsIsOpen: true })
  }
}
